import * as React from "react";
export const LeagueName = (props) => React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__league-name` }, props.leagueName);
//# sourceMappingURL=LeagueName.js.map